<template>
	<div v-if="loaded" id="promobox">
		<div v-if="promo.id" class="promobox loaded">
			<div :class="{activated: activated, hovered: hovered&&activated }"
			class="promo" @click=" hovered=true "
			@mouseover=" hovered=true ">
				<div class="head">
					<span v-if="activated" aria-title="Toggle promo window" class="toggle -top-1/4" @click="hidePromo">
						<svg class="w-2 h-2 t:w-1.5 t:h-1.5" height="29" viewBox="0 0 100 100" width="29" xmlns="http://www.w3.org/2000/svg"> <g transform="rotate(45 -35.355 85.355) scale(14)"><circle fill="#e83443" r="3" stroke="#fff" stroke-width=".75"/><path d="M-2-.5h4v1h-4z" fill="#fff"/><path d="M-.5-2h1v4h-1z" fill="#fff"/></g></svg>
					</span>
					<span v-else  class="toggle up" @click="activated = true">Promo</span>
					<h2 @click="activated=true" >
						<span v-text="promo.callToAction"></span>
						<span v-text="promo.subLine"></span>
					</h2>
				</div>
				<div v-if="promo.image" :style="'background-image: url(/uploads/'+promo.image+')'" class="background_image"></div>
				<p v-text="promo.byline"></p>
				<p class="strong">Enter code <span v-text="promo.code"></span> at checkout.</p>
				<ul>
						<li v-for="term in promo.terms" v-html="term"></li>
				</ul>

			</div>

		</div>

	</div>
</template>

<script>

export default {
	props:[],
	data() {
		return {
			loaded: false,
			activated: true,
			hovered: false,
			promo: [],
			searchRequest: Project.searchRequest,
			bountyLoaded: Promo.bountyLoaded,
			promoDone: []
		}
	},
	mounted() {
		 this.promoDone = this.$cookies.get('promo-close')?this.$cookies.get('promo-close'):[]

		if (Modernizr.cookies && !this.bountyLoaded && window.screen.width < 694){
			this.activated = false
		}

		let token = document.querySelector('meta[name="csrf-token"]').getAttribute('content')
		const options = {
			method: 'POST',
			body: JSON.stringify({search: this.search}),
			headers: {
				'Content-Type': 'application/json',
				'Accept': 'application/json, text-plain, */*',
				'X-Requested-With': 'XMLHttpRequest',
				'X-CSRF-TOKEN': token
			}
		}

		fetch('/api/getpromo', options )
			.then(res => res.json())
			.then(response => {
				this.promo = response
				if (this.promo.id && this.promoDone.indexOf(this.promo.id)>=0){
					this.activated = false
				}
				if (!this.promo.id && this.promoDone.indexOf('B')>=0) {
					this.activated = false
				}
				this.loaded = true
			})

	},
	methods: {
		hidePromo: function (){
			this.activated = false
			let id
			if (this.promo.id){
				id = this.promo.id
			} else {
				id = 'B'
			}
			this.promoDone.push(id)
			this.$cookies.set('promo-close', this.promoDone, 60*24)
		}
	},
	computed: {
		search: function() {
			let searchArray = this.searchRequest.split('&')
			let items

			let keys = searchArray.map(item => {
				items = item.split('=')
				return htmlEntities(items[0])
			})
			let values = searchArray.map(item => {
				items = item.split('=')
				return htmlEntities(items[1])
			})
			let pairs = [keys, values]

			const obj = {}

			for (let i = 0; i < keys.length; i++) {
				obj[ pairs[0][i] ] = pairs[1][i]
			}
			return obj
		},
	}

}

</script>




